// 应用初始状态
const state = {
   showList:true
}
export default state



// WEBPACK FOOTER //
// ./src/vuex/home/state.js